import { ArtTreatmentDefinition, ArtTreatmentIntegrity } from '../models';

/** Tooth IDs that receive the default ART unmovable treatment. */
export const ART_PRESET_TOOTH_IDS = [1, 2, 15, 16, 32, 31, 18, 17] as const;

/** Returns whether an ART treatment has no user-assigned indication. */
export const isArtTreatmentUnassigned = (
	toothId: number | null | undefined,
	integrity: ArtTreatmentIntegrity | undefined,
	definitions: readonly ArtTreatmentDefinition[] | null | undefined
): boolean =>
	(integrity === ArtTreatmentIntegrity.Adjacent && (definitions?.length ?? 0) === 0) ||
	isArtPresetBaseline(toothId, integrity, definitions);

/** Returns whether a tooth ID belongs to the default unmovable molars. */
export const isArtPresetTooth = (toothId: number | null | undefined): boolean =>
	toothId != null && ART_PRESET_TOOTH_IDS.includes(toothId as (typeof ART_PRESET_TOOTH_IDS)[number]);

/** Returns whether tooth is a default unmovable molar */
export const isArtPresetBaseline = (
	toothId: number | null | undefined,
	integrity: ArtTreatmentIntegrity | undefined,
	definitions: readonly ArtTreatmentDefinition[] | null | undefined
): boolean =>
	isArtPresetTooth(toothId) &&
	integrity === ArtTreatmentIntegrity.Adjacent &&
	definitions?.length === 1 &&
	definitions[0] === ArtTreatmentDefinition.Unmovable;
